/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CancellationDeclareResponse interface.
 */
export function instanceOfCancellationDeclareResponse(value) {
    if (!('declarationId' in value) || value['declarationId'] === undefined)
        return false;
    if (!('receivedAt' in value) || value['receivedAt'] === undefined)
        return false;
    return true;
}
export function CancellationDeclareResponseFromJSON(json) {
    return CancellationDeclareResponseFromJSONTyped(json, false);
}
export function CancellationDeclareResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'declarationId': json['declarationId'],
        'receivedAt': (new Date(json['receivedAt'])),
    };
}
export function CancellationDeclareResponseToJSON(json) {
    return CancellationDeclareResponseToJSONTyped(json, false);
}
export function CancellationDeclareResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'declarationId': value['declarationId'],
        'receivedAt': value['receivedAt'].toISOString(),
    };
}
